module.exports = __webpack_public_path__ + "img/6354613696960012505128734.2ce57ea7.jpg";